import "../../index25.css";
import { jsx as i } from "react/jsx-runtime";
import { _ } from "../../cs-Dfox81s-.js";
import "../../type-Dku6Xzl6.js";
import u from "../RawButton/index.js";
const y = "_button_qaoym_1", d = "_round_qaoym_31", p = "_primary_qaoym_34", l = "_secondary_qaoym_51", b = "_tertiary_qaoym_69", t = {
  button: y,
  round: d,
  primary: p,
  secondary: l,
  tertiary: b
};
function B(o) {
  const {
    ariaLabel: r,
    children: a,
    className: n,
    variant: s = "tertiary",
    round: e = !0,
    ...m
  } = o, c = _(
    t.button,
    t[s],
    e && t.round,
    n
  );
  return /* @__PURE__ */ i(
    u,
    {
      className: c,
      "aria-label": r,
      ...m,
      children: a
    }
  );
}
export {
  B as default
};
